import * as d3 from 'd3';
import {
	COLOR_MATRIX,
	GRI_BREAKS,
	SHI_BREAKS,
	MAX_SIZE,
	ASPECT_RATIO,
} from './Constants';

export const lorem =
	() => `Lorem ipsum dolor sit amet, consectetur adipiscing elit.
		Donec vitae nisi vestibulum, fringilla ante in, tincidunt erat.
		Etiam massa ante, rutrum quis aliquam venenatis, lacinia in dui.
		Curabitur dapibus leo arcu, nec varius sapien luctus id. Sed ut velit justo.
		Ut vel vestibulum nisi. Morbi tellus mi, consectetur molestie purus quis,
		feugiat sodales ligula. Etiam vitae fermentum sem. Mauris accumsan dui nec
		lorem tempor dapibus. In ac lacus quis orci tempus placerat.`;

export function parseHex(str) {
	return parseInt(str.substring(1), 16);
}

export function parseColor(color) {
	if (typeof color === 'number') {
		// make sure our hexadecimal number is padded out
		color = `#${`00000${(color | 0).toString(16)}`.substr(-6)}`;
	}

	return color;
}

export const oversaturate = function (color) {
	color.s = 1.6;
	// color.l -= .15;
	console.log(color);
	return color.hex();
};
export const index_breaks = [
	oversaturate(d3.hsl('#f7f3d7')),
	oversaturate(d3.hsl('#f6e9c8')),
	oversaturate(d3.hsl('#f4dbbd')),
	oversaturate(d3.hsl('#f5c6ac')),
];
export const blues = d3.scaleOrdinal(d3.schemeBlues[9]);
export const overall = d3
	.scaleQuantile(4)
	.domain([0, 17])
	.range(d3.schemeOrRd[4]);
export const shi = d3
	.scaleThreshold()
	.domain([0.15, 0.36, 0.72])
	.range(d3.schemeOrRd[4]);
export const gri = d3
	.scaleThreshold()
	.domain([0.24, 0.45, 0.66])
	.range(d3.schemeOrRd[4]);
export const formatValue = d3.format('.2s');

export const bivariateColor = function (gri, shi) {
	function lookup(i, shi) {
		return shi < SHI_BREAKS[0]
			? COLOR_MATRIX[i][0]
			: shi > SHI_BREAKS[0] && shi < SHI_BREAKS[1]
				? COLOR_MATRIX[i][1]
				: shi > SHI_BREAKS[1] && shi < SHI_BREAKS[2]
					? COLOR_MATRIX[i][2]
					: COLOR_MATRIX[i][3];
	}
	for (let i = 0; i < GRI_BREAKS.length + 1; i++) {
		if (
			(i == 0 && gri < GRI_BREAKS[i]) ||
			(gri >= GRI_BREAKS[i - 1] && gri < GRI_BREAKS[i]) ||
			i == GRI_BREAKS.length
		) {
			return lookup(i, shi);
		}
	}
};

export function angle(point1, point2) {
	const dy = point2.y - point1.y;
	const dx = point2.x - point1.x;
	const theta = Math.atan2(dy, dx);
	let angle = ((theta * 180) / Math.PI) % 360;
	angle = angle < 0 ? 360 + angle : angle;
	return angle;
}

export function distance(point1, point2) {
	let xs = 0;
	let ys = 0;
	xs = point2.x - point1.x;
	xs *= xs;
	ys = point2.y - point1.y;
	ys *= ys;
	return Math.sqrt(xs + ys);
}

export const getWidth = function () {
	return document.querySelector('#graphic').clientWidth;
};
export const getHeight = function () {
	return window.innerHeight;
};

// GPU blacklist info https://wiki.mozilla.org/Blocklisting/Blocked_Graphics_Drivers
export const isGPUBlacklisted = function () {
	if (~window.navigator.userAgent.indexOf('Firefox')) {
		const gl = document.querySelector('canvas').getContext('webgl');
		const debugInfo = gl.getExtension('WEBGL_debug_renderer_info'); // const vendor = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
		const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
		if (~vendor.indexOf('ATI')) return true;
	}
	return false;
};

export const createWorker = function (str) {
	const blob = new Blob([str], { type: 'text/javascript' });
	const url = URL.createObjectURL(blob);

	return new Worker(url);
};

export const setHTML = function (str, sel) {
	const fragment = new DOMParser().parseFromString(str, 'text/html');
	document.querySelector(sel).replaceChildren(...fragment.body.children);
};
